import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";
import PartnersBodyComponent from "./partnersBodyComponent";


export default function MainPartnersPage() {
    return (
        <div>
            <NavigationBar />
            <PartnersBodyComponent />
            <FooterComponent />
        </div>
    )
}
